// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriversPauseUI_loader__mI8GO {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.DriversPauseUI_actions__qTBct {
  display: flex;
  align-items: center;
  justify-content: center;
}

.DriversPauseUI_action__oFCqp {
  cursor: pointer;
}

.DriversPauseUI_divider__zl9H6 {
  width: 1px;
  background-color: #C9C9C9;
  height: 22px;
  margin: 0 15px;
}

.DriversPauseUI_history__JyhMl {
  background-color: #fff;
  border-radius: 4px;
  border: 0.5px solid var(--gray);
  padding: 6px 15px;
  display: flex;
  align-items: center;
}

.DriversPauseUI_history__JyhMl span {
  margin-top: 2px;
  margin-left: 10px;
  color: var(--darkGray);
  font-weight: 500;
}

.DriversPauseUI_headerModal__ImeAg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 15px;
}

.DriversPauseUI_titleModal__Ay9MP {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.DriversPauseUI_submit__kye8b {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.DriversPauseUI_labelFormItem__xgTLs {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/drivers-pause/styles/DriversPauseUI.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAEhB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAIA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAGA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":[".loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.action {\n  cursor: pointer;\n}\n\n.divider {\n  width: 1px;\n  background-color: #C9C9C9;\n  height: 22px;\n  margin: 0 15px;\n\n}\n\n.history {\n  background-color: #fff;\n  border-radius: 4px;\n  border: 0.5px solid var(--gray);\n  padding: 6px 15px;\n  display: flex;\n  align-items: center;\n}\n\n.history span {\n  margin-top: 2px;\n  margin-left: 10px;\n  color: var(--darkGray);\n  font-weight: 500;\n}\n\n.headerModal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #cfcfcf;\n  padding-bottom: 15px;\n}\n\n.titleModal {\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n\n\n.submit {\n  width: 250px;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n\n.labelFormItem {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `DriversPauseUI_loader__mI8GO`,
	"actions": `DriversPauseUI_actions__qTBct`,
	"action": `DriversPauseUI_action__oFCqp`,
	"divider": `DriversPauseUI_divider__zl9H6`,
	"history": `DriversPauseUI_history__JyhMl`,
	"headerModal": `DriversPauseUI_headerModal__ImeAg`,
	"titleModal": `DriversPauseUI_titleModal__Ay9MP`,
	"submit": `DriversPauseUI_submit__kye8b`,
	"labelFormItem": `DriversPauseUI_labelFormItem__xgTLs`
};
export default ___CSS_LOADER_EXPORT___;
